module.exports = {"610203001":"城关街道","610203002":"三里洞街道","610203003":"王石凹街道","610203004":"印台街道","610203100":"陈炉镇","610203101":"红土镇","610203102":"广阳镇","610203104":"金锁关镇","610203106":"阿庄镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610203.json
// module id = 2927
// module chunks = 0